import { useMutation, useQuery } from '@tanstack/react-query';
import announcementsService from '../services/announcementsService';

export const useDeleteMultipleAnnouncements = () => {
	return useMutation({
		mutationKey: ['announcements'],
		mutationFn: (data: DeleteMultipleAnnouncementsRequest) =>
			announcementsService.deleteMultipleAnnouncements(data),
	});
};

export const useGetSingleAnnouncement = (
	announcementID: number,
	options?: { isEnabled?: boolean },
) => {
	return useQuery<Announcement>({
		queryKey: ['announcement', announcementID],
		queryFn: () => announcementsService.getSingleResource(announcementID),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useGetAllAnnouncements = (options?: {
	filters?: string;
	isEnabled?: boolean;
}) => {
	return useQuery<TavoittajaApiResponse<{ announcements: Announcement[] }>>({
		queryKey: ['announcements'],
		queryFn: () =>
			announcementsService.getAllResources({
				filters: options?.filters,
			}),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useDeleteAnnouncement = () => {
	return useMutation({
		mutationKey: ['announcements'],
		mutationFn: (id: number) =>
			announcementsService.deleteSingleResource(id),
	});
};

export const useUpdateAnnouncement = () => {
	return useMutation({
		mutationKey: ['announcementUpdate'],
		mutationFn: (data: Partial<UpdateAnnouncementRequest>) =>
			announcementsService.update(data),
	});
};

export const useAddAnnouncement = () => {
	return useMutation({
		mutationKey: ['announcement'],
		mutationFn: (data: AddAnnouncementRequest) =>
			announcementsService.create(data),
	});
};
